export default __webpack_public_path__ + "locales/nl/Webhooks.json?hash=159ca8185c430d2b21c14407ed5078ae";